import React, { useState, useEffect, useRef } from 'react';

import listOpenIcon from '../billingPages/assets/list-open.svg';
import listCloseIcon from '../billingPages/assets/list-close.svg';

import "./CustomSelect.css";

const CustomSelect = ({ placeholder, customSelectList, parentCustomSelect, setParentCustomSelect }) => {

    const [isSelectListOpen, setIsSelectListOpen] = useState(false);

    const [customSearchInput, setCustomSearchInput] = useState('');
    const [customSelectKey, setCustomSelectKey] = useState(parentCustomSelect);
    const [customSelectValue, setCustomSelectValue] = useState(customSelectList[parentCustomSelect]);

    const [customListHighlightedIndex, setCustomListHighlightedIndex] = useState(-1);
    const selectBoxRef = useRef(null);

    const handleListOpen = () => {
        if (Object.keys(customSelectList).length > 0) {
            setIsSelectListOpen(prevState => !prevState);
        }
    };

    const handleCustomSearchInput = (event) => {
        setCustomSelectKey(-1);
        setCustomSelectValue(''); // 입력이 변경되면 선택된 옵션을 초기화

        setCustomSearchInput(event.target.value);
        setIsSelectListOpen(true);

        setCustomListHighlightedIndex(-1);
    };

    const handleItemClick = (key) => {
        setCustomSelectKey(key);
        setCustomSelectValue(customSelectList[key]);
        
        setCustomSearchInput(''); // 선택 후 검색어 초기화
        setIsSelectListOpen(false);
        if (placeholder === "건물을 선택해주세요") {
            sessionStorage.setItem("lastBuilding", key)
        }
        setParentCustomSelect(key);
        
        setCustomListHighlightedIndex(-1);
    };

    const handleClickOutside = (event) => {
        if (selectBoxRef.current && !selectBoxRef.current.contains(event.target)) {
            setIsSelectListOpen(false);

            setCustomListHighlightedIndex(-1);
        }
    };

    const handleKeyDown = (event) => {
        if (event.key === 'ArrowDown') {
            event.preventDefault();
            setCustomListHighlightedIndex(prevIndex =>
                prevIndex < filteredItems.length - 1 ? prevIndex + 1 : 0
            );
        }

        if (event.key === 'ArrowUp') {
            event.preventDefault();
            setCustomListHighlightedIndex(prevIndex =>
                prevIndex > 0 ? prevIndex - 1 : filteredItems.length - 1
            );
        }

        if (event.key === 'Enter') {
            if (customListHighlightedIndex >= 0 && customListHighlightedIndex < filteredItems.length) {
                handleItemClick(filteredItems[customListHighlightedIndex][0]);
            } else {
                const foundKey = Object.keys(customSelectList).find(
                    key => customSelectList[key] === customSearchInput
                );
                if (foundKey) {
                    handleItemClick(foundKey);
                }
            }
            setIsSelectListOpen(false);
        }

        if (event.key === 'Backspace' && customSelectValue) {
            setCustomSelectValue('');
            setIsSelectListOpen(true);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const filteredItems = Object.entries(customSelectList).filter(([key, item]) =>
        item.includes(customSearchInput)
    );
    
    return (
        <div className={`custom-select-box ${parentCustomSelect === null ? 'disabled' : ''}`} onClick={handleListOpen} onKeyDown={handleKeyDown} ref={selectBoxRef} tabIndex="0">
            <input
                type="text"
                className="custom-search-input"
                value={customSelectValue || customSearchInput}
                placeholder={customSelectValue ? '' : placeholder}
                onChange={handleCustomSearchInput}
                disabled={customSelectKey === null}
            />
            <span className={`custom-select-arrow ${isSelectListOpen ? 'open' : ''}`}>
                {isSelectListOpen ? '▲' : '▼'}
            </span>
            {isSelectListOpen && filteredItems.length > 0 && (
                <ul className="custom-list-items">
                    {filteredItems.map(([key, item], index) => (
                        <li
                            key={key}
                            className={`custom-item ${index === customListHighlightedIndex ? 'highlighted' : ''}`}
                            onClick={(e) => {
                                e.stopPropagation();
                                handleItemClick(key);
                            }}
                        >
                            {item}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default CustomSelect;